import { HTTP } from '../../../http-common';
import { httpError } from '../../../models/httpError';

import OtherCharges from '../../../models/OtherCharges';

const state = {
  otherCharges: [new OtherCharges()],
  message: new httpError(),
  services: [],
  servicesItems: [],
};

const getters = {
  otherCharges: (state) => state.otherCharges,
  message: (state) => state.message,
};

const mutations = {
  SET_MESSAGE(state, message) {
    state.message = message;
  },
  GET_OTHER_CHARGES(state, data) {
    state.otherCharges.length = 0;
    state.otherCharges = data;
  },
  UPSERT_OTHER_CHARGES(state, data) {
    state.otherCharges = data;
  },
  DELETE_EXTERNAL_CHARGES(state, index) {
    state.otherCharges.splice(index, 1);
  },
};

const actions = {
  async getExternalCharges({ commit, dispatch }, orderID) {
    try {
      let charges = await HTTP.get('order/GetOtherCharges/' + orderID);

      commit('GET_OTHER_CHARGES', charges.data);
      return Promise.resolve(charges.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error retrieving charges:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },

  async upsertExternalCharges({ commit, dispatch }, payload) {
    try {
      let charges = await HTTP.post(
        'order/UpsertOtherCharge/' + payload.orderID,
        payload.charges
      );
      commit('UPSERT_OTHER_CHARGES', charges);
      dispatch(
        'setMessage',
        new httpError({ message: 'Saved successfully', httpStatus: 200 })
      );
      return Promise.resolve(charges);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error saving charges:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },

  async deleteExternalCharges({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      HTTP.delete('order/DeleteOtherCharges/' + payload.charge, {
        data: payload.index,
      })
        .then((res) => {
          if (res.data) {
            commit('DELETE_OTHER_CHARGES', payload.index);
          }
          resolve(res);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error deleting rows: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  setMessage({ commit }, message) {
    commit('SET_MESSAGE', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('SET_MESSAGE', new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
